<script setup>
import { cn } from "@/lib/utils";

const props = defineProps({
  class: { type: null, required: false },
});
</script>

<template>
  <div
    data-sidebar="footer"
    :class="
      cn(
        'flex flex-col gap-2 px-[15px] pb-[15px] group-data-[collapsible=icon]:px-2',
        props.class,
      )
    "
  >
    <slot />
  </div>
</template>
